export default "__VITE_ASSET__DVTxM5Iw__"